import { FilterState } from 'stores/types';

export const initialState: FilterState = {
  algoliaFilter: '',
  preFilter: {},
  firstSearchPreFilter: {},
  specificationFilter: {},
};
